// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:nbybY_ */\n.LZDRH{grid-gap:var(--audio-spacing-16);display:grid;gap:var(--audio-spacing-16);grid-template-columns:1fr}.RILai{color:var(--audio-content-primary);font-family:var(--font-muse-sans);font-size:var(--audio-font-size-17);font-weight:600;line-height:var(--audio-line-height-24);text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": "LZDRH",
	"title": "RILai"
};
export default ___CSS_LOADER_EXPORT___;
